import React from 'react';
import { Check } from 'lucide-react';
export function FamilyTestimonialsSection() {
  const testimonials = [{
    name: 'Sarah M.',
    review: "I use it every day for my kids' apple snacks. It's so fast and easy—absolutely a must-have kitchen gadget.",
    image: 'https://cdn.magicpatterns.com/uploads/ey92rgFEsQ2P3Ce3NGPjUt/image.png'
  }, {
    name: 'Michael T.',
    review: "Peeling potatoes for dinner used to take forever. Now it's done in minutes. My wife and I both love it.",
    image: 'https://cdn.magicpatterns.com/uploads/mcnmUkk9rnYT3d8zC31P3E/image.png'
  }, {
    name: 'Jennifer K.',
    review: "Bought it for my mom, and she says it's her favorite tool now. She can prepare fruits without any hassle.",
    image: 'https://cdn.magicpatterns.com/uploads/nzqiLqoiAu9B267vENxXMk/image.png'
  }];
  return <div className="w-full max-w-[1400px] mt-16 px-4" data-id="element-141">
      {/* Section Heading */}
      <div className="text-center mb-12" data-id="element-142">
        <h2 className="text-3xl md:text-4xl font-bold text-black mb-4" data-id="element-143">
          Here's Why Thousands of Families Love the Automatic Peeler
        </h2>
        <p className="text-lg text-gray-700" data-id="element-144">
          From daily cooking to big family dinners, this machine saves time,
          effort, and makes kitchen life easier.
        </p>
      </div>

      {/* Testimonials Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-145">
        {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-lg" data-id="element-146">
            {/* Review Text */}
            <div className="p-6" data-id="element-147">
              <p className="text-base text-black leading-relaxed mb-4" data-id="element-148">
                {testimonial.review}
              </p>

              {/* Reviewer Info */}
              <div className="flex items-center gap-3 mb-2" data-id="element-149">
                <div className="w-10 h-10 rounded-full bg-gray-300 flex items-center justify-center" data-id="element-150">
                  <span className="text-sm font-bold text-gray-600" data-id="element-151">
                    {testimonial.name.charAt(0)}
                  </span>
                </div>
                <div data-id="element-152">
                  <div className="font-bold text-black" data-id="element-153">{testimonial.name}</div>
                  <div className="flex items-center gap-1 text-xs text-green-600" data-id="element-154">
                    <span data-id="element-155">Verified purchase</span>
                    <Check className="w-3 h-3" data-id="element-156" />
                  </div>
                </div>
              </div>

              {/* Star Rating */}
              <div className="flex gap-0.5 mb-4" data-id="element-157">
                {[...Array(5)].map((_, i) => <span key={i} className="text-yellow-500 text-lg" data-id="element-158">
                    ⭐
                  </span>)}
              </div>
            </div>

            {/* Product Image */}
            <div className="w-full" data-id="element-159">
              <img src={testimonial.image} alt={`${testimonial.name}'s review`} className="w-full h-auto object-cover" data-id="element-160" />
            </div>
          </div>)}
      </div>
    </div>;
}